import { Backend } from '../_axios';

export default {

  info(jiraKey) {
    return Backend.get(`/api2/project/${jiraKey}/info`);
  },
  info_full(jiraKey) {
    return Backend.get(`/api2/project/${jiraKey}/info_full`);
  },
  editData(jiraKey) {
    return Backend.get(`/api2/project/${jiraKey}/edit`);
  },
  update(data) {
    return Backend.put(`/api2/project/${data.key}`, data);
  },
  createChangeRequest(data) {
    return Backend.post('/api2/project/change_requests', data);
  },
  editChangeRequestData(id) {
    return Backend.get(`/api2/project/change_requests/${id}/edit`);
  },
  updateChangeRequest(data) {
    return Backend.put(`/api2/project/change_requests/${data.id}`, data);
  },
  deleteChangeRequest(id) {
    return Backend.delete(`/api2/project/change_requests/${id}`);
  },
};
